// import '@coreui/coreui/dist/css/coreui.min.css'
// import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css';
import Home from './pages/Home'
import MyOffers from './pages/MyOffers';
import MyListings from './pages/MyListings';
import NotFound from './pages/NotFound';
import ListingsArchive from './pages/ListingsArchive';
import Profile from './pages/Profile';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { ListingContextProvider } from './context/ListingsContext';
import { AuthContext, AuthContextProvider } from './context/AuthContext';
import { LoginModalContextProvider } from './context/LoginModalContext';
import { ChatListingsContextProvider } from './context/ChatsContext';
import NavbarContainer from './components/navbar/Navbar';
import ItemDisplayContainer from './components/listing/ItemDisplayContainer';
// import Sidebar from './components/sidebar/Sidebar';
import Inbox from './pages/Inbox';
import LoadingScreen from './components/helperComponents/LoadingScreen';
import { useContext, useEffect, useState } from 'react';
import "react-loading-skeleton/dist/skeleton.css"
import { SkeletonTheme } from 'react-loading-skeleton';

const App = () => {
  const { currentUser } = useContext(AuthContext)

  // const [messagesBoxOpen, setMessagesBoxOpen] = useState(false)
  // const [inputListingOpen, setInputListingOpen] = useState(false)
  // const toggleMessageBox = () => {
  //   setMessagesBoxOpen(!messagesBoxOpen)
  // }
  // const onCloseMessagesBox = () => {
  //   setMessagesBoxOpen(false)
  // }
  // const [user, setUser] = useState(null)
  // console.log(useContext(AuthContext))
  // const { currentUser } = useContext(AuthContext)
  // console.log(currentUser)

  // const ProtectedRoute = ({ children }) => {
  //   if (!currentUser) {
  //     return <Navigate to="/login"/>
  //   }
  //   return children
  // }


  // useEffect(() => {
  //   const getUser = async () => {
  //     fetch("http://localhost:5000/auth/login/success", {
  //       method:"GET",
  //       credentials:"include",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         "Access-Control-Allow-Credentials": true,
  //       }
  //     }).then((response) => {
  //       console.log(response)
  //       if(response.status === 200) return response.json()
  //       throw new Error("Authentication has failed!")
  //     }).then(resObject => {
  //       setUser(resObject.user)
  //     }).catch(err => {
  //       console.log(err)
  //     })
  //   }
  //   getUser()
  // }, [])
  const [loading, setLoading] = useState(true)

  const handleLoading = () => {
    setLoading(false)
  }

  useEffect(() => {
    window.addEventListener("load", handleLoading())
    return () => window.removeEventListener("load", handleLoading())
  }, [])

  return (
    <SkeletonTheme baseColor="#bebebeff" highlightColor="#888888ff">
    <div>

    {loading ? <LoadingScreen/> :
  

    <BrowserRouter>
      {/* <AuthContextProvider> */}
        <LoginModalContextProvider>
        <div className='app-container'>

          <NavbarContainer/>

          <div className='app-content'>
            {/* <ListingContextProvider>
              <Sidebar/>
            </ListingContextProvider> */}
            <Routes>
              <Route 
                path="*" 
                element={
                  currentUser ? 
                  <NotFound/> :
                  <Navigate to="/"/>
                }/>
              {/* <Route 
                path="/signup" 
                // element={ currentUser ? <Navigate to="/"/> : <Login/>}
                element={
                  currentUser ? 
                  <Navigate to="/"/> :
                  <Signup/>
                }
              /> */}
              <Route 
                path="/" 
                // element={ 
                //   currentUser ? 
                //   <ListingContextProvider>
                //     <Home/>
                //   </ListingContextProvider> :
                //   <Navigate to="/login"/>
                // }
                element={ 
                    // <PrivateRoute>
                      <ListingContextProvider>
                          <Home/>
                      </ListingContextProvider> 
                    // </PrivateRoute>
                }
                // element={<Home/>}
              />
              <Route path="/user/:userId" 
                element={
                  currentUser ? 
                  <Profile/> :
                  <Navigate to="/"/>
                }
              />

              <Route path="/item/:listingId" 
                element={
                //   currentUser ? 
                  <ListingContextProvider>
                    <ItemDisplayContainer />
                  </ListingContextProvider> 
                  // :
                  // <Navigate to="/"/>
                }
              />

              <Route path="/myoffers" 
                element={
                  currentUser ? 
                  <MyOffers/> :
                  <Navigate to="/"/>
                }
              />
              <Route path="/mylistings" 
                element={
                  currentUser ? 
                  <ListingContextProvider>
                    <MyListings/>
                  </ListingContextProvider>:
                  <Navigate to="/"/>
                } 
              />
              <Route path="/inbox" 
                element={
                  currentUser ? 
                  // <ChatListingsContextProvider>
                    <Inbox/> 
                  // </ChatListingsContextProvider> 
                  :
                  <Navigate to="/"/>
                } 
              />
              {/* <Route path="/chat/:chatId" 
                element={
                  currentUser ? 
                    <ChatRoom/> 
                  :
                  <Navigate to="/"/>
                } 
              /> */}
              <Route path="/archive" 
                element={
                  currentUser ? 
                  <ListingsArchive/> :
                  <Navigate to="/"/>
                } 
              />
              {/* <Route path="/password" 
                element={
                  currentUser ? 
                  <ChangePasswordForm/> :
                  <Navigate to="/"/>
                }
              /> */}
              
            </Routes>

          </div>
        </div>
        </LoginModalContextProvider>
      {/* </AuthContextProvider> */}
    </BrowserRouter>
    
    }
  </div>
  </SkeletonTheme>
  );
}

export default App;
